import React, { useEffect, useContext, useState } from "react";
import { ConfigContext } from "../../Context/ConfigContext";
import axios from "axios";
import "./credit.css";
import { BoxArrowRight, Download } from "react-bootstrap-icons";
import Config from "../../appConfig";
import { axiosGet } from "../../Apis/axiosMethods";


export default function AccountLocked() {
  const { business_id } = useContext(ConfigContext);
  const [statements, setStatements] = useState([]);

  useEffect(() => {
    GetBusinessInfo();
  }, [])

  const handleDownloadStatement = () => {
    var url = `${Config.statement_api}/public/statements/${statements[0].credit_statement}`;
    window.open(url, '_blank');
  };

  const handleLogout = () => {
    LogoutHandle();
  };

  const GetBusinessInfo = async () => {
    try {
      const response = await axiosGet(`/Users/GetBusinessInfo`, { business_id });

      if (response?.success) {
        setStatements(response?.statements || []);

      } else {
        console.log("Error While Fetching Business Info", response.message);
      }
    } catch (error) {
      console.log("Error fetching business info:", error);
    }
  }
  const LogoutHandle = () => {
    localStorage.setItem('token', '');
    localStorage.setItem('business_user_id', '');
    localStorage.setItem('business_id', '');
    localStorage.setItem('user_name', '');
    localStorage.setItem('business_name', '');
    localStorage.setItem('business_contact_number', '');
    localStorage.removeItem('carts');
    localStorage.removeItem('AccountLocked');
    // ClearCart();

    window.location = '/Login';
  }

  return (
    <div className="d-flex justify-content-center align-items-center vh-100 bg-light">
      <div className="card shadow-lg border-0" style={{ maxWidth: "500px" }}>
        <div className="card-body text-center p-4">
          <div className="mb-3">
            <div className="bg-danger bg-opacity-10 d-inline-flex p-3 rounded-circle">
              <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="white" className="bi bi-lock" viewBox="0 0 16 16">
                <path fill-rule="evenodd" d="M8 0a4 4 0 0 1 4 4v2.05a2.5 2.5 0 0 1 2 2.45v5a2.5 2.5 0 0 1-2.5 2.5h-7A2.5 2.5 0 0 1 2 13.5v-5a2.5 2.5 0 0 1 2-2.45V4a4 4 0 0 1 4-4M4.5 7A1.5 1.5 0 0 0 3 8.5v5A1.5 1.5 0 0 0 4.5 15h7a1.5 1.5 0 0 0 1.5-1.5v-5A1.5 1.5 0 0 0 11.5 7zM8 1a3 3 0 0 0-3 3v2h6V4a3 3 0 0 0-3-3" />
              </svg>
            </div>
          </div>
          <h3 className="fw-bold text-dark">Account Temporarily Locked</h3>
          <p className="text-muted mt-2">
            For your security, your account access has been paused until we receive your pending statement.
          </p>
          <p className="text-secondary small">
            We understand this may cause inconvenience. Please complete your pending statement to regain full access.
          </p>

          <button className="btn btn-primary w-100 mb-3" onClick={handleDownloadStatement}>
            View Pending Statement
          </button>

          <div className="d-flex justify-content-between">
            <button className="btn btn-outline-secondary flex-fill me-2" onClick={handleDownloadStatement}>
              <Download className="me-2" /> Download Statement
            </button>
            <button className="btn btn-outline-danger flex-fill ms-2" onClick={handleLogout}>
              <BoxArrowRight className="me-2" /> Logout
            </button>
          </div>

          <p className="small text-muted mt-4">
            If you believe this is an error, our support team will be happy to assist you.
          </p>
        </div>
      </div>
    </div>
  );
}
